// extracted by mini-css-extract-plugin
export var author = "newsletter-signup-module--author--9b846";
export var category = "newsletter-signup-module--category--8333c";
export var description = "newsletter-signup-module--description--6e920";
export var errorMessage = "newsletter-signup-module--error-message--f756b";
export var formWrapper = "newsletter-signup-module--form-wrapper--221a7";
export var headline = "newsletter-signup-module--headline--c7a58";
export var headlinePost = "newsletter-signup-module--headline-post--90af4";
export var iconWrapper = "newsletter-signup-module--icon-wrapper--a73f7";
export var inputWrapper = "newsletter-signup-module--input-wrapper--436f8";
export var newsletterSignup = "newsletter-signup-module--newsletter-signup--bed26";
export var paragraph = "newsletter-signup-module--paragraph--08254";
export var privacyPolicy = "newsletter-signup-module--privacy-policy--a59c1";
export var privacyPolicyCheckbox = "newsletter-signup-module--privacy-policy-checkbox--ec50e";
export var privacyPolicyLabel = "newsletter-signup-module--privacy-policy-label--2cbdd";
export var result = "newsletter-signup-module--result--c99df";
export var signupButton = "newsletter-signup-module--signup-button--b322a";
export var title = "newsletter-signup-module--title--4eb39";